export default {
    methods: {
        getCellStyle({ column }) {
            const tempWidth = column.realWidth || column.width
            return {
                minWidth: tempWidth + 'px',
                maxWidth: tempWidth + 'px'
            }
        }
    }
}
